import {StarIcon} from '@primer/octicons-react'

import {Link} from '@primer/react'

import type {BaseServer} from '../../../../types'

import {InstallButton} from '../../../../components/InstallButton/InstallButton'

import styles from './GridCard.module.css'

type Props = {
  mcp: BaseServer
}

export function GridCard(props: Props) {
  const {mcp} = props

  const owner = mcp.name_with_owner ? mcp.name_with_owner.split('/')[0] : null

  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.heading}>
            {mcp.owner_avatar_url ? (
              <div className={styles.logoContainer}>
                <img src={mcp.owner_avatar_url} alt={`${mcp.display_name} logo`} className={styles.logo} />
              </div>
            ) : null}

            <Link href={`/mcp/${mcp.name}`} className={styles.link}>
              {mcp.display_name}
            </Link>
          </div>

          <div className={styles.isolate}>
            <InstallButton mcp={mcp} muted />
          </div>
        </div>

        <p className={styles.description}>{mcp.description}</p>
      </div>

      <footer className={styles.footer}>
        {owner ? (
          <p className={styles.footerOwner}>
            By <span>{owner}</span>
          </p>
        ) : null}

        {mcp.stargazer_count ? (
          <div className={styles.footerStats}>
            <StarIcon size={14} />

            <span>{mcp.stargazer_count.toLocaleString()}</span>
          </div>
        ) : null}
      </footer>
    </div>
  )
}
